export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '患教直播平台',
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description 封面兜底图（未上传封面/背景图时使用，与首页列表一致）
   */
  defaultCover: '/static/img/back2.png',
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    // dev: 'http://localhost:8081/',
    dev: 'https://yxzh.watch.life-oasis.com/api/',
    pro: 'https://yxzh.watch.life-oasis.com/api/'
  },
  wsUrl: {
    dev: 'yxzh.watch.life-oasis.com/',
    pro: 'yxzh.watch.life-oasis.com/'
  },
  /**
   * @description 阿里云播放器 License 配置
   * domain 必须与实际部署域名一致,否则播放器会终止播放
   * ⚠️ 本地开发时改为 localhost,部署后改回生产域名
   */
  aliplayerLicense: {
    key: 'GPb28iIutuHskm4eM783ee4cafe1c4e689a333149b1fdb1cb',
    // domain: 'localhost',  // ⚠️ 本地开发用 - 部署前改为 'gxcd-tech.com'
    domain: 'gxcd-tech.com'  // 生产环境用
  },
  /**
   * @description 直播拉流地址域名（SRS 拼接模式使用）
   * 实测：live.gxcd-tech.com DNS 不可达（已废弃）；live.life-oasis.com 返回 200 可用。
   * dev/pro 均使用完整域名，不依赖部署侧 nginx 反代 /live/，与移动端 yixiu_live_user/utils/config.js 保持一致。
   * 本地调试需拉流服务器已开启 CORS（live.life-oasis.com 已开），否则可在 webpack devServer 配代理
   */
  streamDomain: {
    dev: 'https://live.gxcd-tech.com',
    pro: 'https://live.gxcd-tech.com'
  },
  // baseUrl: {
  //   dev: 'http://localhost/',
  //   pro: 'http://live.51sunjet.cn/'
  // },
  // wsUrl: {
  //   dev: 'localhost:9889/',
  //   pro: 'live.51sunjet.cn/'
  // },
  /**
   * @description 默认打开的首页的路由name值，默认为index
   */
  homeName: 'index',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  },
  build: {
    assetsPublicPath: './'
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js